import { FormattedMessage } from 'react-intl'
import { keepPreviousData } from '@tanstack/react-query'

import { useMediaQuery } from '@gto/ui/hooks/use-media-query'
import { Paper } from '@gto/ui/paper'
import { Typography } from '@gto/ui/typography'

import { useHomepageStatsRetrieve } from '@/api/gen'
import Bg from '@/assets/images/espen-gto.png'

export const GTOFreeBanner = () => {
  const isSmAndLower = useMediaQuery('down', 'sm')
  const { data } = useHomepageStatsRetrieve({
    query: {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 10,
      enabled: true,
      placeholderData: keepPreviousData,
    },
  })

  return (
    <Paper
      as="aside"
      className="relative rounded-md border border-divider px-16 py-8 before:absolute before:-top-6 before:right-0 before:h-[calc(100%+24px)] before:w-full before:bg-[image:var(--bg-image)] before:bg-contain before:bg-[position:bottom_right] before:bg-no-repeat before:content-[''] md:px-8 md:py-4 md:before:bg-[length:400px] md:before:bg-[position:bottom_right_-70px] sm:px-4 sm:py-3 sm:before:bg-[length:250px] sm:before:bg-[position:bottom_right_-50px] [@media(max-width:500px)]:before:bg-[length:180px]"
      elevation="1"
      style={{
        ['--bg-image' as string]: `url(${Bg})`,
      }}
    >
      <div className="flex flex-col">
        <div className="max-w-[70%] md:max-w-[55%] sm:max-w-[75%]">
          <Typography
            gutterBottom
            className="text-[24px] font-semibold sm:text-[20px]"
            color="primary"
            variant="h5"
          >
            <FormattedMessage
              id="deals.gtoFree.title"
              values={{ sum: data?.min_rake_for_gto_wizard_sub }}
            />
          </Typography>
          <Typography
            className="text-[16px] font-semibold sm:text-[12px]"
            color="text.primary"
            variant="body1"
          >
            <FormattedMessage
              id={isSmAndLower ? 'deals.gtoFree.description.mobile' : 'deals.gtoFree.description'}
            />
          </Typography>
        </div>
      </div>
    </Paper>
  )
}
